
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-list",
      function () {
        return require("private-next-pages/video-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-list"])
      });
    }
  